'use strict';

angular.module('selfAccessRequestAdHocRoutes', ['selfAccessRequestRoutes'])

.config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
    $stateProvider

        // adHoc
        .state('selfAccessRequest.adHoc', {
            url: '/AdHoc',
            abstract: true,
            views: {
                '': {
                    templateUrl: require('./AdHoc.tpl.html'),
                    controller: 'AdHocController'
                },
                'sideBar@selfAccessRequest.adHoc': {
                    templateUrl: require('./SideBar.tpl.html'),
                }
            },
        })

        // Remove Rights
        .state('selfAccessRequest.adHoc.welcome', {
            url: '/RemoveRights/Explanation',
            views: {
                'main@selfAccessRequest.adHoc': {
                    controller: 'AdHocRemoveRightsExplanationController',
                    templateUrl: require('./removeRights/adhocWelcome.tpl.html'),
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["RemoveRights"][0];
                        }]
                    }
                }
            }
        })
        .state('selfAccessRequest.adHoc.removeRights', {
            url: '/RemoveRights/{employeeID}/SystemType',
            views: {
                'main@selfAccessRequest.adHoc': {
                    controller: 'AdHocRemoveRightsSystemTypeListController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'removeRights');
                        }]
                    }
                }
            }
        })
        .state('selfAccessRequest.adHoc.removeRightsBySystemType', {
            url: '/RemoveRights/SystemType/{systemTypeSlug}',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./removeRights/RemoveRights.tpl.html'),
                    controller: 'AdHocRemoveRightsBySystemTypeController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'RemoveRights');
                        }],
                        decisionBySystemType: ['decisionSystemTypesList', '$stateParams', function (decisionSystemTypesList, $stateParams) {
                            return _.find(decisionSystemTypesList, { Slug: $stateParams.systemTypeSlug });
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["RemoveRights"][0];
                        }]
                    }
                }
            }
        })

        // Pre Authorized
        .state('selfAccessRequest.adHoc.preAuthorizedHelp1', {
            url: '/PreAuthorized/Explanation',
            views: {
                'main@selfAccessRequest.adHoc': {
                    controller: 'AdHocPreAuthorizedExplanationController',
                    templateUrl: require('./preAuthorized/PreAuthorizedExplanation1.tpl.html'),
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["PreAuthorized"][0];
                        }]
                    }
                }
            }
        })
        .state('selfAccessRequest.adHoc.preAuthorized', {
        url: '/PreAuthorized/{employeeID}/SystemType',
        views: {
            'main@selfAccessRequest.adHoc': {
                controller: 'AdHocPreAuthorizedSystemTypeListController',
                resolve: {
                    decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                        return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'preAuthorized');
                    }]
                }
            }
        }
    })
        .state('selfAccessRequest.adHoc.preAuthorizedBySystemType', {
            url: '/PreAuthorized/SystemType/{systemTypeSlug}',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./preAuthorized/PreAuthorized.tpl.html'),
                    controller: 'AdHocPreAuthorizedBySystemTypeController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'preAuthorized');
                        }],
                        decisionBySystemType: ['decisionSystemTypesList', '$stateParams', function (decisionSystemTypesList, $stateParams) {
                            return _.find(decisionSystemTypesList, { Slug: $stateParams.systemTypeSlug });
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["PreAuthorized"][0];
                        }]
                    }
                }
            }
        })

        // Same As
        .state('selfAccessRequest.adHoc.sameAs', {
            url: '/SameAs/{sameAsEmployeeID}/SystemType',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./sameAs/SameAs.tpl.html'),
                    controller: 'AdHocSameAsSystemTypeListController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'sameAs');
                        }]
                    }
                }
            }
        })
        .state('selfAccessRequest.adHoc.sameAsBySystemType', {
            url: '/SameAs/{sameAsEmployeeID}/SystemType/{systemTypeSlug}',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./sameAs/SameAs.tpl.html'),
                    controller: 'AdHocSameAsBySystemTypeController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'sameAs');
                        }],
                        decisionBySystemType: ['decisionSystemTypesList', '$stateParams', function (decisionSystemTypesList, $stateParams) {
                            return _.find(decisionSystemTypesList, { Slug: $stateParams.systemTypeSlug });
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["SameAs"][0];
                        }]
                    }
                },
                'sideBar@selfAccessRequest.adHoc': {
                    templateUrl: require('./SideBarForSameAs.tpl.html'),
                    controller: 'AdHocSideBarSameAsController'
                }
            }
        })

        // Other Catalog
        .state('selfAccessRequest.adHoc.otherCatalog', {
            url: '/OtherCatalog',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./otherCatalog/OtherCatalog.tpl.html'),
                    controller: 'AdHocOtherCatalogController',
                    resolve: {
                        decisionSystemTypesList: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                            return service.getUserSystemRoleDecisionsByProcessStep($stateParams.userAccessRequestId, 'OtherCatalogPermissions');
                        }],
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["OtherCatalogPermissions"][0];
                        }]
                    }
                }
            }
        })

        // Other Needs
        .state('selfAccessRequest.adHoc.otherNeeds', {
            url: '/OtherNeeds',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./specialNeeds/OtherNeeds.tpl.html'),
                    controller: 'AdHocOtherNeedsController',
                    resolve: {
                        processStep: ['processStepsByStepName', function (processStepsByStepName) {
                            return processStepsByStepName["SpecialNeeds"][0];
                        }]
                    }
                }
            }
        })

        // Additional Steps
        .state('selfAccessRequest.adHoc.additionalSteps', {
            url: '/AdditionalSteps',
            views: {
                'main@selfAccessRequest.adHoc': {
                    templateUrl: require('./AdHocAdditionalSteps.html'),
                }
            }
        })

         // Validation
        .state('selfAccessRequest.adHoc.validation', {
         url: '/Validation',
         views: {
             'main@selfAccessRequest.adHoc': {
                 templateUrl: require('./submit/AdHocConfirmation.html'),
                 controller: 'AdHocConfirmationController',
                 resolve: {
                     decisionListWithImpact: ['selfAccessRequestService', '$stateParams', function (service, $stateParams) {
                         return service.getUserSystemRoleDecisionsToValidate($stateParams.userAccessRequestId);
                     }],
                     processStep: ['processStepsByStepName', function (processStepsByStepName) {
                         return processStepsByStepName["Submit"][0];
                     }],
                     specialNeedsFollowup: ['$stateParams', 'selfAccessRequestService', function ($stateParams, service) {
                         return service.getSpecialNeedsFollowup($stateParams.userAccessRequestId)
                     }],

                }
             }
         }
     })

}]);
